/**
 * Copy of the AMS View page itself (`components/Ams/view/AmsViewPage.tsx`).
 * Spread into `en.amsView`; owns the `page` sub-key. VentaHub's English,
 * verbatim (cited).
 */
export const amsViewPage = {
  // AmsViewPage.tsx:1834, 1935-1937
  page: {
    title: 'AMS View',
    description: 'Ad spend, sales, and campaign performance across your AMS accounts.',
  },
} as const
